import { z } from '../../../zod';

export const PagePaymentMethodsInputValidationSchema = z
  .object({
    stripe: z
      .object({
        card: z
          .object({
            enabled: z.boolean().nullish(),
          })
          .nullish(),
        agpay: z
          .object({
            enabled: z.boolean().nullish(),
            mode: z.enum(['express', 'default']).nullish().meta({
              description:
                'Express mode auto-fills customer details and may skip some checkout fields.',
            }),
          })
          .nullish()
          .meta({
            description: 'Configure Apple Pay and Google Pay availability on this page.',
          }),
        multiple: z
          .object({
            enabled: z.boolean().nullish(),
          })
          .nullish()
          .meta({
            description:
              'Enable additional Stripe payment methods such as wallets, BNPL options, bank debits, and local methods. Requires [Stripe payment method configuration](https://dashboard.stripe.com/settings/payment_methods). [Learn more](https://checkoutpage.com/docs/articles/accept-multiple-payment-methods).',
          }),
      })
      .nullish(),
  })
  .meta({
    id: 'PagePaymentMethodsInput',
    description: 'Payment method configuration for Stripe.',
    examples: [
      {
        stripe: {
          card: {
            enabled: true,
          },
          agpay: {
            enabled: true,
            mode: 'default',
          },
          multiple: {
            enabled: false,
          },
        },
      },
    ],
  });
